import clsx from "clsx";
import { useAtom } from "jotai";

import { CplOfferPageFooter } from "./components/cpl-offer-page-footer/cpl-offer-page-footer.component";
import { CplOfferPageHeader } from "./components/cpl-offer-page-header/cpl-offer-page-header.component";
import { CplTile } from "./components/cpl-tile/cpl-tile.component";
import { REDIRECT_IF_PAGE_ERROR_DELAY_SECONDS } from "./cpl-offer-page.constants";
import { cplOfferPageAtom, currentCplPageAtom } from "./cpl-offer-page.state";

export function Widget() {
  const [cplOfferPage] = useAtom(cplOfferPageAtom);
  const [currentCplPage] = useAtom(currentCplPageAtom);
  const { newGridUI } = window.FKL;

  return (
    <div className="cpl-offer-page">
      {cplOfferPage.allowedPage ? (
        <>
          <CplOfferPageHeader />
          <div
            className={clsx(
              "cpl-offer-page__body",
              newGridUI && "cpl-offer-page-v2"
            )}
          >
            {!newGridUI && (
              <div className="cpl-offer-page__body--title">
                Click to select {currentCplPage.minimumCplOffersTaken} or more
                offers to earn extra entries:
              </div>
            )}
            <div className="cpl-offer-page__body--tiles">
              {currentCplPage.cpls.map((cpl, index) => (
                <CplTile key={cpl.id} {...{ id: cpl.id, index }} />
              ))}
            </div>
          </div>
          <CplOfferPageFooter />
        </>
      ) : (
        <div className="error-message">
          You&apos;ve already seen this page.{" "}
          <strong>
            You will be redirected to the next page in{" "}
            {REDIRECT_IF_PAGE_ERROR_DELAY_SECONDS} seconds.
          </strong>
        </div>
      )}
    </div>
  );
}

declare global {
  interface FKL {
    sweepstakeId: string;
    assetWidgetUrl: string;
    minimumCplOffersTaken: number;
    displayEntriesPopup: boolean;
    allowSkipPages: boolean;
    newGridUI: boolean;
  }
}
